import { ReactSVG } from "react-svg";

// Helpers
import { classNames } from "helpers";

// UI
import { Badge } from "ui/components/Badge";
import { BadgeProps } from "ui/components/Badge/types";
import { PictureIcon } from "ui/components/Pictures";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

import { DamagePinRow } from "./types";

/** Boja statusa iz baze → Tailwind klasa točke, odnosno varijanta Badge-a. */
export const STATUS_DOT_COLORS: Record<string, string> = {
  orange: "bg-orange-500",
  blue: "bg-blue-500",
  green: "bg-green-500",
  slate: "bg-slate-500",
};

export const STATUS_BADGE_VARIANT: Record<string, BadgeProps["variant"]> = {
  orange: "warning",
  blue: "info",
  green: "success",
  slate: "secondary",
};

export const DAMAGE_PIN_COLUMNS = (
  onEditClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void,
  onDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "admin.fleet.vehicle.damage.pin.name",
    key: "pin_name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: DamagePinRow) => (
      <div className="flex items-center gap-3">
        {/* Ista boja kojom je pin ucrtan na fotografiji — veže redak i točku na slici. */}
        <span
          className={classNames(
            "w-3 h-3 rounded-full flex-shrink-0",
            STATUS_DOT_COLORS[row.statusColor ?? "orange"] ?? "bg-orange-500"
          )}
        />
        <span className="text-md font-medium text-slate-600 truncate">
          {row.name || "Bez naziva"}
        </span>
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.damage.pin.description",
    key: "pin_description",
    field: "",
    type: ColumnTypes.custom,
    render: (row: DamagePinRow) => (
      <div className="text-sm text-slate-900 truncate max-w-[220px]">
        {row.description || "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.damage.pin.status",
    key: "pin_status",
    field: "",
    type: ColumnTypes.custom,
    render: (row: DamagePinRow) =>
      row.statusName ? (
        <Badge
          text={row.statusName}
          variant={STATUS_BADGE_VARIANT[row.statusColor ?? "slate"] ?? "info"}
          height="small"
          showDot
        />
      ) : (
        <div className="text-sm text-slate-400">-</div>
      ),
  },
  {
    title: "admin.fleet.vehicle.damage.pin.photo",
    key: "pin_photo",
    field: "",
    type: ColumnTypes.custom,
    render: (row: DamagePinRow) => (
      <div className="flex items-center gap-2 min-w-0">
        <PictureIcon
          url={row.photoUrl ?? undefined}
          fileName={row.photoName ?? undefined}
          tooltip={row.photoName ?? undefined}
          size="sm"
        />
        <span className="text-sm text-slate-500 truncate max-w-[160px]">
          {row.photoName ?? "-"}
        </span>
      </div>
    ),
  },
  {
    title: "",
    key: "pin_actions",
    field: "",
    type: ColumnTypes.custom,
    render: (row: DamagePinRow) => (
      <div className="flex justify-end items-center gap-3 h-[30px]">
        <div
          onClick={(event) => onEditClick(event, row.id)}
          className="cursor-pointer"
          title="Uredi"
        >
          <ReactSVG
            src="/media/icons/edit.svg"
            className="w-4 h-4 [&_svg]:w-4 [&_svg]:h-4 [&_path]:stroke-slate-500 hover:[&_path]:stroke-sky-600"
          />
        </div>
        <div
          onClick={(event) => onDeleteClick(event, row.id)}
          className="cursor-pointer"
          title="Obriši"
        >
          <ReactSVG
            src="/media/icons/trash.svg"
            className="w-4 h-4 [&_svg]:w-4 [&_svg]:h-4 stroke-[#bd0000]"
          />
        </div>
      </div>
    ),
  },
];
